import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import "./abonentplata.css";

// =============================================
// Вместо import january from "./datebase/january"
// данные загружаются через fetch из MySQL
// =============================================
const API = "/php";

const Abonentplata = ({ setChecked, sentTelegram }) => {
    useEffect(() => { setChecked("1"); }, []);

    const currentMonth = new Date().getMonth() + 1;
    const [checkedMonth, setCheckedMonth] = useState(`${currentMonth}`);
    const [checkedFilter, setCheckedFilter] = useState("1");
    const [zagolovkachoose, setzagolovkachoose] = useState("all");
    const [viewerlist, setviewerlist] = useState([]);
    const [loading, setLoading] = useState(false);
    const [profilAbonent, setprofilAbonent] = useState(0);
    const [editinput, seteditinput] = useState(false);
    const [editValues, setEditValues] = useState({});
    const [searchTerm, setSearchTerm] = useState("");
    const location = useLocation();

    // =============================================
    // Загрузка данных месяца из MySQL
    // =============================================
    useEffect(() => {
        const fetchMonth = async () => {
            setLoading(true);
            try {
                const res = await fetch(`${API}/get_abonentplata.php?month=${checkedMonth}`);
                const data = await res.json();
                if (data.status === "success") {
                    setviewerlist(data.data);
                } else {
                    console.error("Ошибка загрузки:", data.message);
                    setviewerlist([]);
                }
            } catch (err) {
                console.error("Fetch error:", err);
                setviewerlist([]);
            } finally {
                setLoading(false);
            }
        };
        fetchMonth();
    }, [checkedMonth]);

    // =============================================
    // Активный месяц (CSS)
    // =============================================
    useEffect(() => {
        if (location.pathname !== "/") return;
        for (let i = 1; i <= 12; i++) {
            const el = document.querySelector(`.abonentplata-month-span${i}`);
            if (el) el.classList.toggle("active", checkedMonth === String(i));
        }
    }, [checkedMonth, location.pathname]);

    // =============================================
    // Активный фильтр (CSS)
    // =============================================
    useEffect(() => {
        if (location.pathname !== "/") return;
        for (let i = 1; i <= 6; i++) {
            const el = document.querySelector(`.abonentplata-filter-span${i}`);
            if (el) el.classList.toggle("active", checkedFilter === String(i));
        }
    }, [checkedFilter, location.pathname]);

    // =============================================
    // Активный способ оплаты (CSS)
    // =============================================
    useEffect(() => {
        const map = { all: 1, nal: 2, per: 3 };
        [1, 2, 3].forEach(i => {
            const el = document.querySelector(`.abonentplata-list-zagolovka-choose-span${i}`);
            if (el) el.classList.toggle("active", map[zagolovkachoose] === i);
        });
    }, [zagolovkachoose]);

    // =============================================
    // Профиль абонента (CSS)
    // =============================================
    useEffect(() => {
        const el = document.querySelector(".abonent-profil");
        if (el) el.classList.toggle("active", profilAbonent > 0);
    }, [profilAbonent]);

    // =============================================
    // Заполнение editValues при выборе абонента
    // =============================================
    useEffect(() => {
        if (!profilAbonent || !viewerlist.length) { setEditValues({}); return; }
        const profil = viewerlist.find(x => x.id === profilAbonent);
        if (!profil) { setEditValues({}); return; }
        setEditValues({
            name: profil.name ?? profil.account_name ?? "",
            phoneNumber: profil.phoneNumber ?? profil.phone ?? "",
            inn: profil.inn ?? "",
            objectAbonent: profil.objectAbonent ?? profil.units_count ?? 0,
            abonentplataAbonent: profil.abonentplataAbonent ?? profil.price_per_unit ?? 0,
            objectSim: profil.objectSim ?? profil.object_sim ?? 0,
            abonentplataSim: profil.abonentplataSim ?? profil.abonentplata_sim ?? 0,
            objectRouming: profil.objectRouming ?? profil.object_roaming ?? 0,
            abonentplataRouming: profil.abonentplataRouming ?? profil.abonentplata_roaming ?? 0,
            abonentplataMethod: profil.abonentplataMethod ?? profil.abonentplata_method ?? "",
            prihod: "",
            rasxod: ""
        });
    }, [profilAbonent, viewerlist]);

    // Закрытие профиля по Escape
    useEffect(() => {
        const handleEsc = (e) => {
            if (e.key === "Escape") {
                setprofilAbonent(0);
                seteditinput(false);
                setSearchTerm("");
            }
        };
        window.addEventListener("keydown", handleEsc);
        return () => window.removeEventListener("keydown", handleEsc);
    }, []);

    const handleChange = (key, value) => {
        setEditValues(prev => ({ ...prev, [key]: value }));
    };

    // =============================================
    // Добавление записи в приход/расход денег
    // =============================================
    const addMoneyEntry = async (entryPayload) => {
        try {
            if (entryPayload.summa !== undefined) {
                const num = Number(entryPayload.summa);
                entryPayload.summa = Number.isFinite(num) ? String(num) : entryPayload.summa;
            }
            const res = await fetch(`${API}/add_money.php`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(entryPayload),
            });
            const json = await res.json();
            return json;
        } catch (err) {
            console.error("add_money error:", err);
            return { ok: false, error: err.message };
        }
    };

    // =============================================
    // Сохранение профиля абонента
    // =============================================
    const handleSave = async (e) => {
        e?.preventDefault?.();
        if (!profilAbonent) return;

        const hasValues = Object.values(editValues).some(v => v !== "" && v !== null && v !== undefined);
        if (!hasValues) return;

        const profil = viewerlist.find(x => x.id === profilAbonent);
        const balance = Number(profil?.balance ?? 0);
        const prihod = parseInt(editValues.prihod) || 0;
        const rasxod = parseInt(editValues.rasxod) || 0;
        const newBalance = Math.round((balance + prihod - rasxod) * 100) / 100;
        const newDebt = newBalance < 0 ? Math.abs(newBalance) : 0;

        const fieldsToSave = { ...editValues, balance: newBalance, debt: newDebt };

        try {
            const response = await fetch(`${API}/save_account.php`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ id: profilAbonent, fields: fieldsToSave, month: checkedMonth }),
            });
            const result = await response.json();

            if (result.status === "success") {
                const nameText = editValues.name || profil?.name || profil?.account_name || "Неизвестно";
                const payMethod = editValues.abonentplataMethod ?? profil?.abonentplataMethod ?? "";
                const payMethodText = payMethod === "nal" ? "Наличка" : payMethod === "per" ? "Перечисление" : "Неизвестно";

                if (prihod > 0) {
                    await addMoneyEntry({ typeMoney: payMethodText, operation: "Приход", source: "Абонентская плата", name: nameText, summa: String(prihod), month: checkedMonth });
                    await sentTelegram({ typeMoney: payMethodText, operation: "Приход", source: "Абонентская плата", name: nameText, summa: String(prihod) });
                }
                if (rasxod > 0) {
                    await addMoneyEntry({ typeMoney: payMethodText, operation: "Расход", source: "Абонентская плата", name: nameText, summa: String(rasxod), month: checkedMonth });
                    await sentTelegram({ typeMoney: payMethodText, operation: "Расход", source: "Абонентская плата", name: nameText, summa: String(rasxod) });
                }

                // Обновляем локальный стейт
                setviewerlist(prev => prev.map(u =>
                    u.id === profilAbonent ? { ...u, ...fieldsToSave } : u
                ));
                seteditinput(false);
                setEditValues(prev => ({ ...prev, prihod: 0, rasxod: 0 }));
            } else {
                alert("Ошибка сохранения: " + (result.message || JSON.stringify(result)));
            }
        } catch (err) {
            console.error("handleSave error:", err);
            alert("Ошибка сети при сохранении.");
        }
    };

    const formatSum = (sum) => Number(sum ?? 0).toLocaleString('ru-RU');

    // Нормализация полей (MySQL возвращает snake_case, JSX ждёт camelCase)
    const norm = (e) => ({
        ...e,
        name: e.name ?? e.account_name ?? "",
        object: Number(e.object ?? e.units_count ?? 0),
        balance: Number(e.balance ?? 0),
        abonentplataMethod: e.abonentplataMethod ?? e.abonentplata_method ?? "",
        objectAbonent: Number(e.objectAbonent ?? e.units_count ?? 0),
        abonentplataAbonent: Number(e.abonentplataAbonent ?? e.price_per_unit ?? 0),
        objectSim: Number(e.objectSim ?? e.object_sim ?? 0),
        abonentplataSim: Number(e.abonentplataSim ?? e.abonentplata_sim ?? 0),
        objectRouming: Number(e.objectRouming ?? e.object_roaming ?? 0),
        abonentplataRouming: Number(e.abonentplataRouming ?? e.abonentplata_roaming ?? 0),
        phoneNumber: e.phoneNumber ?? e.phone ?? "",
        new: e.is_new == 1 || e.is_new === true || e.new === true,
        deleted: e.deleted == 1 || e.deleted === true,
    });

    return (
        <section className="abonentplata">
            <div className="abonentplata-flex">
                {/* ----- Месяцы ----- */}
                <div className="abonentplata-month">
                    <div className="abonentplata-month-h5">
                        <h5>{new Date().getFullYear()}</h5>
                    </div>
                    {[["1", "Январь"], ["2", "Февраль"], ["3", "Март"], ["4", "Апрель"],
                    ["5", "Май"], ["6", "Июнь"], ["7", "Июль"], ["8", "Август"],
                    ["9", "Сентябрь"], ["10", "Октябрь"], ["11", "Ноябрь"], ["12", "Декабрь"]
                    ].map(([num, label]) => (
                        <span key={num}
                            className={`abonentplata-month-span abonentplata-month-span${num}`}
                            onClick={() => setCheckedMonth(num)}>
                            {label}
                        </span>
                    ))}
                </div>

                {/* ----- Список ----- */}
                <div className="abonentplata-list">
                    <div className="abonentplata-list-zagolovka">
                        <div className="abonentplata-list-zagolovka-kolvo">
                            <h3>Общее количество объектов:</h3>
                            <span>
                                {(viewerlist || []).reduce((sum, item) => {
                                    const e = norm(item);
                                    return sum + (e.deleted !== true ? Number(e.object) || 0 : 0);
                                }, 0)}
                            </span>
                        </div>
                        <div className="abonentplata-filter">
                            <span className="abonentplata-filter-span abonentplata-filter-span1" onClick={() => setCheckedFilter("1")}>Все клиенты</span>
                            <span className="abonentplata-filter-span abonentplata-filter-span2" onClick={() => setCheckedFilter("2")}>Новые клиенты</span>
                            <span className="abonentplata-filter-span abonentplata-filter-span3" onClick={() => setCheckedFilter("3")}>Удаленные</span>
                            <span className="abonentplata-filter-span abonentplata-filter-span6" onClick={() => setCheckedFilter("6")}>Роуминг</span>
                            <span className="abonentplata-filter-span abonentplata-filter-span4" onClick={() => setCheckedFilter("4")}>Оплаченные</span>
                            <span className="abonentplata-filter-span abonentplata-filter-span5" onClick={() => setCheckedFilter("5")}>Долг</span>
                        </div>
                        <div className="abonentplata-list-zagolovka-choose">
                            <span className="abonentplata-list-zagolovka-choose-span">
                                <span className="abonentplata-list-zagolovka-choose-span1" onClick={() => setzagolovkachoose("all")}>Все</span>
                                <span className="abonentplata-list-zagolovka-choose-span2" onClick={() => setzagolovkachoose("nal")}>Наличка</span>
                                <span className="abonentplata-list-zagolovka-choose-span3" onClick={() => setzagolovkachoose("per")}>Перечисление</span>
                            </span>
                        </div>
                        <div className="abonentplata-search">
                            <span>
                                <h3><i className="fas fa-search"></i></h3>
                                <input type="text" placeholder="Поиск....." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
                            </span>
                        </div>
                    </div>

                    {/* ----- Профиль абонента ----- */}
                    <div className="abonent-profil" onClick={() => { setprofilAbonent(0); seteditinput(false); }}>
                        <div className="abonent-profil-box" onClick={(e) => e.stopPropagation()}>
                            {viewerlist.map(item => {
                                const e = norm(item);
                                if (e.id !== profilAbonent) return null;
                                return (
                                    <span key={e.id} className="abonent-profil-box1">
                                        <div className="abonent-profil-box1-texts1">
                                            <span className="abonent-profil-box1-text1">
                                                <h3>Наименование (ФИО, Название компаний):</h3>
                                                <h4>{e.name}</h4>
                                            </span>
                                            <span className="abonent-profil-box1-text1-1">
                                                <span className={`abonent-profil-box1-text1-span1 ${editinput ? "active" : ""}`}>
                                                    <h3>Контакты клиента:</h3>
                                                    <input onChange={(ev) => handleChange("phoneNumber", ev.target.value)} className={`input-edit ${editinput ? "active" : ""}`} readOnly={!editinput} type="text" defaultValue={e.phoneNumber} />
                                                </span>
                                                <span className={`abonent-profil-box1-text1-span1 ${editinput ? "active" : ""}`}>
                                                    <h3>ИНН/ПНФЛ:</h3>
                                                    <input onChange={(ev) => handleChange("inn", ev.target.value)} className={`input-edit ${editinput ? "active" : ""}`} readOnly={!editinput} type="text" defaultValue={e.inn} />
                                                </span>
                                            </span>
                                            <span className="abonent-profil-box1-text1-1">
                                                <span className="abonent-profil-box1-text1-2">
                                                    <h3>Объекты:</h3>
                                                    <h4>{e.object}</h4>
                                                </span>
                                                <span className="abonent-profil-box1-text1-2">
                                                    <h3>Баланс:</h3>
                                                    <h4>{formatSum(e.balance)} сум</h4>
                                                </span>
                                                <span className="abonent-profil-box1-text1-2">
                                                    <h3>Плата за месяц:</h3>
                                                    <h4>{((e.objectSim * e.abonentplataSim) + (e.objectRouming * e.abonentplataRouming) + (e.objectAbonent * e.abonentplataAbonent)).toLocaleString('ru-RU')} сум</h4>
                                                </span>
                                                <span className={`abonent-profil-box1-text1-2 ${editinput ? "active" : ""}`}>
                                                    <h3>Тип оплаты:</h3>
                                                    <select className="abonentplataMethod-select"
                                                        value={editValues.abonentplataMethod || e.abonentplataMethod}
                                                        onChange={(ev) => handleChange("abonentplataMethod", ev.target.value)}
                                                        disabled={!editinput}>
                                                        <option value="per">Перечисление</option>
                                                        <option value="nal">Наличка</option>
                                                    </select>
                                                </span>
                                            </span>
                                        </div>
                                        <div className="abonent-profil-box1-texts2">
                                            <span className="abonent-profil-box1-text2"><h3>Абонентские платы:</h3></span>
                                            {[
                                                ["SIM + Server", "objectAbonent", "abonentplataAbonent"],
                                                ["Роуминг", "objectRouming", "abonentplataRouming"],
                                                ["Только SIM", "objectSim", "abonentplataSim"],
                                            ].map(([label, objKey, priceKey]) => (
                                                <span key={label} className="abonent-profil-box1-text1">
                                                    <h3>{label}:</h3>
                                                    <span className="abonent-profil-box1-text1-span">
                                                        <span className={`abonent-profil-box1-text1-span1 ${editinput ? "active" : ""}`}>
                                                            <h3>Кол-во:</h3>
                                                            <input onChange={(ev) => handleChange(objKey, parseInt(ev.target.value))} className={`input-edit ${editinput ? "active" : ""}`} readOnly={!editinput} type="number" defaultValue={e[objKey]} />
                                                        </span>
                                                        <span className={`abonent-profil-box1-text1-span1 ${editinput ? "active" : ""}`}>
                                                            <h3>Сумма за ед.:</h3>
                                                            <input onChange={(ev) => handleChange(priceKey, parseInt(ev.target.value))} className={`input-edit ${editinput ? "active" : ""}`} readOnly={!editinput} type="number" defaultValue={e[priceKey]} />
                                                        </span>
                                                    </span>
                                                </span>
                                            ))}
                                        </div>
                                        {String(currentMonth) === checkedMonth && (
                                            <>
                                                <div className="abonent-profil-box1-texts3">
                                                    <div className="abonent-profil-box1-texts3-flex-boxs">
                                                        {[["prihod", "abonent-profil-box1-texts3-flex-box1-prixod", "Приход"],
                                                        ["rasxod", "abonent-profil-box1-texts3-flex-box1-rasxod", "Расход"]
                                                        ].map(([key, cls, label]) => (
                                                            <div key={key} className="abonent-profil-box1-texts3-flex-box1">
                                                                <h3 className={cls}>{label}</h3>
                                                                <span className={`abonent-profil-box1-text1-span1 ${editinput ? "active" : ""}`}>
                                                                    <input
                                                                        value={editValues[key] ?? ""}
                                                                        onChange={(ev) => handleChange(key, ev.target.value === "" ? "" : parseInt(ev.target.value))}
                                                                        className={`input-edit ${editinput ? "active" : ""}`}
                                                                        readOnly={!editinput}
                                                                        type="number"
                                                                    />
                                                                </span>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                                <div className="abonent-profil-box1-texts4">
                                                    <div onClick={() => seteditinput(true)}>Править</div>
                                                    <div onClick={handleSave}>Сохранить</div>
                                                </div>
                                            </>
                                        )}
                                    </span>
                                );
                            })}
                        </div>
                    </div>

                    {/* ----- Таблица ----- */}
                    {loading ? (
                        <div className="loader"></div>
                    ) : (
                        <table className="abonentplata-list-table">
                            <thead>
                                <tr className="abonentplata-list-table-sticky">
                                    <th>№</th>
                                    <th>Имя</th>
                                    <th>Количество объектов</th>
                                    <th>Баланс</th>
                                    <th>Способ оплаты</th>
                                </tr>
                            </thead>
                            <tbody>
                                {(viewerlist || [])
                                    .map(norm)
                                    .filter(koks => {
                                        const matchesSearch = koks.name.toLowerCase().includes(searchTerm.toLowerCase());
                                        let matchesFilter = true;
                                        if (checkedFilter === "1") matchesFilter = !koks.deleted;
                                        else if (checkedFilter === "2") matchesFilter = koks.new && !koks.deleted;
                                        else if (checkedFilter === "3") matchesFilter = koks.deleted;
                                        else if (checkedFilter === "4") matchesFilter = koks.balance >= 0;
                                        else if (checkedFilter === "5") matchesFilter = koks.balance < 0;
                                        else if (checkedFilter === "6") matchesFilter = koks.objectRouming > 0;
                                        let matchesPayment = true;
                                        if (zagolovkachoose === "nal") matchesPayment = koks.abonentplataMethod === "nal";
                                        else if (zagolovkachoose === "per") matchesPayment = koks.abonentplataMethod === "per";
                                        return matchesSearch && matchesFilter && matchesPayment;
                                    })
                                    .map(koks => (
                                        <tr key={koks.id}
                                            onClick={() => setprofilAbonent(koks.id)}
                                            style={{
                                                color: koks.balance < 0 ? "red" : "black",
                                                backgroundColor: koks.balance < 0 ? "#ffe5e5" : ""
                                            }}>
                                            <td>{koks.id}</td>
                                            <td>{koks.name}</td>
                                            <td>{koks.object}</td>
                                            <td>{formatSum(koks.balance)}</td>
                                            <td>
                                                {koks.abonentplataMethod === "per" ? "Перечисление"
                                                    : koks.abonentplataMethod === "nal" ? "Наличка"
                                                        : "Неизвестно"}
                                            </td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </table>
                    )}
                </div>
            </div>
        </section>
    );
};

export default Abonentplata;
